var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-table',{attrs:{"table-header-color":_vm.tableHeaderColor},scopedSlots:_vm._u([{key:"md-table-row",fn:function(ref){
var item = ref.item;
return _c('md-table-row',{},[_c('md-table-cell',{attrs:{"md-label":"Ticker"}},[_vm._v(_vm._s(item.ticker))]),_vm._v(" "),_c('md-table-cell',{attrs:{"md-label":"Percent Change"}},[_vm._v(_vm._s(item.percent))])],1)}}]),model:{value:(_vm.positions),callback:function ($$v) {_vm.positions=$$v},expression:"positions"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e158282","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Trading/CurrentPositionsDash.vue
// module id = null
// module chunks = 